// extracted by mini-css-extract-plugin
export var container = "layout-module--container--78b04";